<template>
  <div
    style="
      height: 100vh;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      border-top: 0.5px solid #e2e2e2;
    "
  >
    <van-nav-bar
      :left-text="['/', '/self'].includes(route.path) ? '' : '返回'"
      :left-arrow="!['/', '/self'].includes(route.path)"
      van-nav-bar
      safe-area-inset-top
      @click-left="$router.go(-1)"
    >
      <template #title>
        {{ $store.state.loginUser?.name }}
        <text v-if="$store.state.loginUser?.department_name">{{
          "/" + $store.state.loginUser?.department_name
        }}</text>
      </template>
    </van-nav-bar>
    <div
      van-number-keyboard
      safe-area-inset-bottom
      style="flex: 1; overflow: hidden; padding-bottom: 40px"
    >
      <router-view />
    </div>
    <van-tabbar route safe-area-inset-bottom>
      <van-tabbar-item
        replace
        :to="{ name: 'Main' }"
        :icon="route.path == '/' ? 'gold-coin' : 'gold-coin-o'"
      >
        工资条
      </van-tabbar-item>
      <van-tabbar-item
        replace
        to="/self"
        :icon="route.path == 'self' ? 'contact' : 'contact-o'"
      >
        个人档案
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { useRoute } from "vue-router";
import { get_loginuser } from "@/http/api";
import store from "@/store";
export default {
  setup() {
    const route = useRoute();
    const state = reactive({});
    onMounted(() => {
      store.commit("setLoginUser", {
        id: 2,
        account: "admin2",
        phone: "13322222222",
        name: "测试账号",
        sex: "男",
        email: "1@1.com",
        leader_type: "0,1,2",
        is_super_auth: 0,
        menus: "1,2",
        job: "操作员",
        department_id: 1,
        login_count: 257,
        login_ip: "192.168.3.204",
        login_time: "2024-12-12 16:35:01",
        status: 1,
        create_time: "2023-09-08 17:26:27",
        update_time: "2024-12-12 16:35:01",
        is_del: 0,
        department_name: "远创人力资源管理集团有限公司",
      });
      get_loginuser().then((res) => {
        if (res.status == 200) store.commit("setLoginUser", res.data.data);
      });
    });

    return { state, route };
  },
};
</script>
<style scoped></style>
